// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__p1bJZ","col":"styles_col__PI3xv","actions":"styles_actions__1cfCJ","conflict":"styles_conflict__10GGW"};